<script>
  import {marked} from 'marked';

  export let image;
  export let name;
  export let description;
  export let reversed;
</script>

<div class="row author--container mt-5 {reversed ? 'flex-lg-row-reverse text-lg-end' : ''}">
  <div class="col-12 col-lg-3 col-xxl-2 d-flex d-lg-block justify-content-center">
    <div class="author--image">
      <img class="img-fluid" src="{image}" alt="{name} - zdjęcie" />
    </div>
  </div>
  <div
    class="d-flex flex-column justify-content-center col-12 col-lg-9 col-xxl-6 {reversed ? 'pe-lg-5' : 'ps-lg-5'}"
  >
    <h2 class="author--name mb-4 mt-5 mt-md-4 mt-lg-0 ">{name}</h2>
    <p data-aos="fade-up" data-aos-offset="100" class="description">
      {@html marked(description)}
    </p>
  </div>
</div>

<style>
  .description {
    font-family: "Work Sans";
    font-size: 14px;
    line-height: 16px;
    color: #425466;
  }

  .author--image {
    display: inline-flex;
    border-radius: 50%;
    border: 3px solid #fdcd18;
    padding: 6px;
  }
  .author--image img {
    border-radius: 50%;
    object-fit: cover;
  }

  .author--name {
    font-family: "Work Sans";
    font-weight: 600;
    font-size: 24px;
    color: #27272e;
  }
</style>
